// 本地环境配置
module.exports = {
  baseApi: "/hw/api",
  appBaseUrl: `/mobile`,
  appQkzqBaseUrl: "/appQkzq",
};
